import React from "react";
import { useTranslation } from "react-i18next";

// common
import Modal, { ModalText, ModalLayout, MoreModalButtons } from "common/modal";
import { useNavigate } from "react-router-dom";

const { ConfirmationText } = ModalText;
const { ModalRow } = ModalLayout;
const { ModalButtonYellow, ButtonContainer } = MoreModalButtons;

type OverlappingClassModalProps = {
  visible: boolean;
  onCloseModal: () => void;
};

const OverlappingClassModal = ({
  visible,
  onCloseModal,
}: OverlappingClassModalProps) => {
  const { t } = useTranslation("book_a_class");
  const navigate = useNavigate();

  return (
    <Modal
      title={t("SCHEDULING CONFLICT")}
      centered
      visible={visible}
      footer={null}
      onCancel={onCloseModal}
    >
      <ConfirmationText>
        {t(
          "You have another class booked for the same time slot. To book this class, you need to cancel the other booked class in My Classes page."
        )}
      </ConfirmationText>
      <ModalRow>
        <ButtonContainer xs={18}>
          <ModalButtonYellow
            type="primary"
            onClick={() => navigate("/my-classes")}
          >
            {t("MY CLASSES")}
          </ModalButtonYellow>
        </ButtonContainer>
      </ModalRow>
    </Modal>
  );
};

export default OverlappingClassModal;
